/* ============================================================
   lp-store.js — LP Perluna · JS mínimo para las secciones lp-* fuera de la landing
   (marquee, encabezado, pie, colección) dentro de layout/theme.liquid.
   Basado en ref/script_acc.js. Sin jQuery. Nunca lanza si faltan elementos.
   Extra (revisión r1): sincroniza el contador del carrito del header con el evento 'cart-update' de Dawn.
   Se carga con defer; guarda global window.__lpStoreBooted.
   ============================================================ */
(function(){
  if(window.__lpStoreBooted) return; window.__lpStoreBooted=1;

  function each(list,fn){ if(!list) return; for(var i=0;i<list.length;i++){ try{ fn(list[i]); }catch(e){} } }
  function qsa(sel,root){ try{ return (root||document).querySelectorAll(sel); }catch(e){ return []; } }
  function byId(id){ try{ return document.getElementById(id); }catch(e){ return null; } }

  /* ---- menú móvil: toggle/remove de .open en TODOS los .bhead ---- */
  if(typeof window.bmenuToggle!=="function"){
    window.bmenuToggle=function(){ each(qsa(".bhead"),function(h){ h.classList.toggle("open"); }); };
  }
  if(typeof window.bmenuClose!=="function"){
    window.bmenuClose=function(){ each(qsa(".bhead"),function(h){ h.classList.remove("open"); }); };
  }

  /* ---- CTA "comprar": desplaza al bloque de compra si existe; si no, deja navegar el href ---- */
  if(typeof window.scrollBundles!=="function"){
    window.scrollBundles=function(e){
      var t=byId("bundles")||byId("lpBundles")||byId("lpReleasitHost");
      if(!t) return;
      try{ if(e&&typeof e.preventDefault==="function") e.preventDefault(); }catch(err){}
      try{ t.scrollIntoView({behavior:"smooth",block:"center"}); }catch(err){ try{ t.scrollIntoView(); }catch(e2){} }
    };
  }

  /* ---- carrito: fuera de la landing no hay cajón (#cartDr) → ir a /cart ---- */
  if(typeof window.cartOpen!=="function"){
    window.cartOpen=function(){
      if(byId("cartDr")) return;
      var root="/";
      try{ if(window.Shopify&&Shopify.routes&&Shopify.routes.root) root=String(Shopify.routes.root); }catch(e){}
      if(root.charAt(root.length-1)!=="/") root+="/";
      try{ window.location.href=root+"cart"; }catch(e){}
    };
  }

  /* ---- marquee: duplicar la pista una sola vez (por nodo, no por id) ---- */
  function lpMarquee(){
    each(qsa(".mqtrack"),function(t){
      if(t.getAttribute("data-lp-dup")) return;
      t.setAttribute("data-lp-dup","1");
      t.innerHTML+=t.innerHTML;
    });
  }

  /* ---- reveal: añade .in al entrar en viewport (o a todos sin IntersectionObserver) ---- */
  var io=null;
  function getIO(){
    if(io) return io;
    if(!("IntersectionObserver" in window)) return null;
    try{
      io=new IntersectionObserver(function(en){
        each(en,function(x){ if(x.isIntersecting){ x.target.classList.add("in"); io.unobserve(x.target); } });
      },{threshold:.1});
    }catch(e){ io=null; }
    return io;
  }
  function lpReveal(){
    var els=qsa(".lpx .reveal"), obs=getIO();
    each(els,function(el){
      if(el.classList.contains("in")) return;
      if(!obs){ el.classList.add("in"); return; }
      if(el.getAttribute("data-lp-obs")) return;
      el.setAttribute("data-lp-obs","1");
      obs.observe(el);
    });
  }

  /* ---- contador del carrito del header (.bcart .ccount / #cartCount) ----
     Fuera de la landing el carrito lo gestiona Dawn (cajón cart-drawer + Section Rendering) y nadie
     re-renderiza el contador de lp-header → se sincroniza con /cart.js cuando Dawn publica el evento
     'cart-update' de pubsub.js (añadir al carrito, cambiar cantidades) y al volver desde bfcache. */
  function lpApplyCount(n){
    if(typeof n!=="number"||n<0) return;
    each(qsa(".lpx .bcart .ccount"),function(el){ el.textContent=String(n); el.style.display=n?"":"none"; });
  }
  function lpCartCount(ev){
    if(!qsa(".lpx .bcart .ccount").length) return;
    try{ if(ev&&ev.cartData&&typeof ev.cartData.item_count==="number"){ lpApplyCount(ev.cartData.item_count); return; } }catch(e){}
    if(typeof window.fetch!=="function") return;
    var root="/";
    try{ if(window.Shopify&&Shopify.routes&&Shopify.routes.root) root=String(Shopify.routes.root); }catch(e){}
    if(root.charAt(root.length-1)!=="/") root+="/";
    try{
      window.fetch(root+"cart.js",{credentials:"same-origin",headers:{"Accept":"application/json"}})
        .then(function(r){ return r&&r.ok?r.json():null; })
        .then(function(c){ if(c) lpApplyCount(c.item_count); })
        .catch(function(){});
    }catch(e){}
  }
  window.lpCartCount=lpCartCount;
  try{
    var cartEv="cart-update";
    try{ if(typeof PUB_SUB_EVENTS!=="undefined"&&PUB_SUB_EVENTS&&PUB_SUB_EVENTS.cartUpdate) cartEv=PUB_SUB_EVENTS.cartUpdate; }catch(e){}
    if(typeof subscribe==="function") subscribe(cartEv,function(ev){ lpCartCount(ev); });
  }catch(e){}
  try{ window.addEventListener("pageshow",function(ev){ if(ev&&ev.persisted) lpCartCount(); }); }catch(e){}

  function lpStoreRefresh(){ try{ lpMarquee(); }catch(e){} try{ lpReveal(); }catch(e){} }
  window.lpStoreRefresh=lpStoreRefresh;

  /* ---- editor de temas ---- */
  try{ document.addEventListener("shopify:section:load",function(){ lpStoreRefresh(); }); }catch(e){}

  /* ---- arranque ---- */
  if(document.readyState==="loading"){
    document.addEventListener("DOMContentLoaded",lpStoreRefresh);
  }else{
    lpStoreRefresh();
  }
})();
